if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {
		constructor(){
			super();
			this.ajaxifyCartItems();
		}
		ajaxifyCartItems(){
			this.form = this.querySelector('form');
			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{
				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}
				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 300));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}
			})
		}

		updateCartQty(item, newQty){
			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}
			const body = JSON.stringify({
				// id: item.dataset.id,
				quantity: newQty,
				line: +item.dataset.line
			});
			fetch(KROWN.settings.routes.cart_change_url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
				body
			})
			.then(response => {
				if ( response.ok ) {
					return fetch('?section_id=helper-cart')
				} else {
					throw new Error('Something went wrong');
				}
			})
			.then(response => response.text())
			.then(text => {
				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
				const cartItems = document.getElementById('AjaxCartForm');
				cartItems.innerHTML = cartFormInnerHTML;
				cartItems.ajaxifyCartItems();
				fetch('/cart.js')
				.then(res => res.json())
				.then(cart => {
					if (window.updateFreeShippingBar) {
					window.updateFreeShippingBar(cart.total_price);
					}
				});
				document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
					elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
				});
				document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
					elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
				});
				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
				// Check free gift eligibility after cart update
				if (typeof free_product_added === 'function') {
				 	free_product_added();
				}
			})
			.catch(e => {
				console.log(e);
				let alert = document.createElement('span');
				alert.classList.add('alert', 'alert--error');
				alert.textContent = KROWN.settings.locales.cart_general_error;
				this.form.prepend(alert);
			})
			.finally(() => {
				this.form.classList.remove('processing');
			});
		}
	}
	if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}
}

if ( typeof CartProductQuantity !== 'function' ) {
	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  	if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}
}

// method for apps to tap into and refresh the cart
if ( ! window.refreshCart ) {
	window.refreshCart = () => {	
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();
			fetch('/cart.js')
			.then(res => res.json())
			.then(cart => {
			if (window.updateFreeShippingBar) {
				window.updateFreeShippingBar(cart.total_price);
			}
			});
			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			document.getElementById('site-cart-sidebar').show();
		})
	}
}

window.updateFreeShippingBar = function(cartTotalInCents) {
	// Cart total ko main currency format me convert karein (Shopify cents me return karta hai)
	const cartTotal = cartTotalInCents / 100;
	const targetAmount = 2500; // Target limit
	const shippingBar = document.getElementById('free-shipping-bar');
	const textElement = document.getElementById('free-shipping-text');
	const fillElement = document.getElementById('free-shipping-progress-fill');
	if (!shippingBar || !textElement || !fillElement) return;

	if (cartTotal >= targetAmount) {
		// Limit complete hone par
		textElement.innerHTML = '🎉 Congratulations! You’ve unlocked <strong>Free Mini Lipstick</strong>!';
		fillElement.style.width = '100%';
		fillElement.style.backgroundColor = '#4caf50'; // Green color
	} else {
		// In-progress state
		const remaining = targetAmount - cartTotal;
		const percentage = Math.min((cartTotal / targetAmount) * 100, 100);
		textElement.innerHTML = `Add <strong>Rs. ${remaining.toFixed(0)}</strong> more to get <strong>Free Mini Lipstick</strong>!`;
		fillElement.style.width = `${percentage}%`;
		fillElement.style.backgroundColor = '#ff9800'; // Orange/In-progress color
	}
};

let isUpdatingCart = false;

// Liquid tag injection for dynamic gift product variant ID
const GIFT_VARIANT_ID = typeof gift_product !== 'undefined' 
    ? gift_product 
    : 67790729642299;

window.free_product_added = function() {
    if (isUpdatingCart) return;

    setTimeout(() => {
        if (isUpdatingCart) return;
        isUpdatingCart = true;

        fetch('/cart.json')
            .then(res => {
                if (!res.ok) throw new Error(`Cart fetch failed: ${res.status}`);
                return res.json();
            })
            .then(data => {
                // Calculate cart total excluding gift items
                let cart_item_total = 0;
                data.items.forEach(item => {
                    const isGift = item.vendor === 'Gift' || 
                                   (item.vendor && item.vendor.includes('Gift')) || 
                                   (item.title && item.title.includes('Free')) ||
                                   item.variant_id === GIFT_VARIANT_ID;
                    if (!isGift) {
                        cart_item_total += item.final_line_price;
                    }
                });
                cart_item_total = cart_item_total / 100; // Convert cents to currency unit
                
                const cart_free_product = data.items.find(item => item.variant_id === GIFT_VARIANT_ID);

                if (cart_item_total >= 2500) {
                    if (!cart_free_product) {
                        return fetch('/cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] })
                        })
                        .then(res => res.json())
                        .then(response => {
                            if (response.status === 422 || response.errors) {
                                console.error('Gift product is unavailable or sold out.');
                                return;
                            }
                            console.log('Free gift added');
                            if (typeof window.refreshCart === 'function') {
                                window.refreshCart();
                            }
                        });
                    }
                } else {
                    if (cart_free_product) {
                        return fetch('/cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                id: cart_free_product.key,
                                quantity: 0
                            })
                        })
                        .then(res => res.json())
                        .then(() => {
                            console.log('Free product removed');
                            if (typeof window.refreshCart === 'function') {
                                window.refreshCart();
                            }
                        });
                    }
                }
            })
            .catch(err => {
                console.error('Error during free product sync:', err);
            })
            .finally(() => {
                // Throttle lock release to prevent infinite event loops
                setTimeout(() => {
                    isUpdatingCart = false;
                }, 1000);
            });
    }, 500);
}

document.addEventListener('DOMContentLoaded', () => {
  	fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
		if (window.updateFreeShippingBar) {
			window.updateFreeShippingBar(cart.total_price);
		}
    });
	free_product_added();
});